<template>
  <div class="pa-3 grey lighten-4">
    <v-card fill-height>
      <v-card-title class="grey lighten-4 pa-2">
        <h3 class="secondary--text">{{ $t("company.details.title") }}</h3>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="onSaveDetails()" small>Save</v-btn>
      </v-card-title>

      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <!-- Films Details Languages -->
            <v-card elevation="2" tile class="mb-4">
              <v-card-title>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-tabs
                        background-color="transparent"
                        color="basil"
                        grow
                        v-model="widget_language"
                    >
                      <v-tab
                        v-for="language in enabledLanguages" :key="language.value"
                      >
                          {{ language.text }}
                      </v-tab>
                    </v-tabs>
                  </v-flex>
                  <v-flex xs6>
                    <div v-if="widget_language === 0">
                      <v-tooltip 
                        bottom
                        max-width="300"
                        color="grey darken-3"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            color="grey lighten-3"
                            class="override-btn"
                            outlined
                            style="float:right"
                            small
                            @click="setFieldLanguageData(['title','subtitle','description'], film)"
                          >
                          {{ $t('language_copy_all_button_label') }}
                          </v-btn>
                        </template>
                        <div class="pa-2">
                          <div class="body-2">{{ $t('language_copy_all_button_info') }}</div>
                        </div>
                      </v-tooltip>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="mt-4">
                <v-tabs-items v-model="widget_language">
                  <v-tab-item
                      v-for="language in enabledLanguages"
                      :key="language.name"
                  >
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        v-model="film.title[language.value]"
                        :label="$t('screener.film.title')"
                        color="primary"
                        :rules="[
                          rules.required,
                          rules.min_length(3),
                          rules.max_length(250),
                        ]"
                        counter="250"
                      >
                        <v-tooltip slot="append" color="white" top>
                          <v-icon slot="activator">$vuetify.icons.rms_help_circle</v-icon>
                          <span class="greyDarken3--text body-1">{{
                            $t("rms.help.text.film.input_field.title")
                          }}</span>
                        </v-tooltip>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="film.subtitle[language.value]"
                        :label="$t('screener.film.subtitle')"
                        color="primary"
                        :rules="[rules.min_length(3), rules.max_length(250)]"
                        counter="250"
                      >
                        <v-tooltip slot="append" color="white" top>
                          <v-icon slot="activator">$vuetify.icons.rms_help_circle</v-icon>
                          <span class="greyDarken3--text body-1">{{
                            $t("rms.help.text.film.input_field.original_title")
                          }}</span>
                        </v-tooltip>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <!-- Description -->
                      <TextEditor
                        :title="$t('screener.film.description')"
                        v-model="film.description[language.value]"
                      />
                    </v-flex>
                  </v-layout>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
            <!-- Films Details Languages -->
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <!-- <v-flex xs12>
            <v-text-field
              v-model="film.title"
              :label="$t('screener.film.title')"
              color="primary"
              :rules="[
                rules.required,
                rules.min_length(3),
                rules.max_length(250),
              ]"
              counter="250"
            >
              <v-tooltip slot="append" color="white" top>
                <v-icon slot="activator">$vuetify.icons.rms_help_circle</v-icon>
                <span class="greyDarken3--text body-1">{{
                  $t("rms.help.text.film.input_field.title")
                }}</span>
              </v-tooltip>
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="film.subtitle"
              :label="$t('screener.film.subtitle')"
              color="primary"
              :rules="[rules.min_length(3), rules.max_length(250)]"
              counter="250"
            >
              <v-tooltip slot="append" color="white" top>
                <v-icon slot="activator">$vuetify.icons.rms_help_circle</v-icon>
                <span class="greyDarken3--text body-1">{{
                  $t("rms.help.text.film.input_field.original_title")
                }}</span>
              </v-tooltip>
            </v-text-field>
          </v-flex> -->
          <v-layout row wrap class="pt-2">
            <v-flex xs2 class="pl-1 pr-4">
              <v-text-field
                v-model="film.length"
                :label="$t('rms.field.length.label')"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 class="pl-1 pr-4">
              <v-combobox
                v-model="film.directors"
                :items="filmMakers.data"
                :search-input.sync="search"
                :hide-no-data="!search"
                hide-selected
                multiple
                small-chips
                item-text="name"
                item-value="id"
                :label="$t('screener.film.director.title')"
              >
                <!-- New Entity -->
                <template v-slot:no-data>
                  <v-list-tile class="text-xs-center">
                    <span class="subheading" v-html="$t('media.manager.filmmaker.attachment.combo.box.not.found.message', { director: search })"></span>
                    <v-btn :loading="loading" @click="createFilmMaker" small color="success">
                      {{ $t('media.manager.filmmaker.attachment.combo.box.not.found.create.btn') }}
                    </v-btn>
                  </v-list-tile>
                </template>

                <!-- Selection slot -->
                <template v-slot:selection="{ item, parent, selected }">
                  <v-chip :selected="selected" label small>
                    <v-avatar v-if="item.profile_url">
                      <img :src="item.profile_url" alt="director">
                    </v-avatar>
                    {{ item.name[currentLocale] }}
                    <v-icon small @click.stop="parent.selectItem(item)">close</v-icon>
                  </v-chip>
                </template>

                <!-- Item slot -->
                <template v-slot:item="{ index, item }">
                  <v-list-tile-avatar>
                    <img :src="item.profile_url">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <div class="subheading">{{ item.name[currentLocale] }}</div>
                  </v-list-tile-content>
                  <v-spacer></v-spacer>
                  <v-list-tile-action>
                    <v-btn small icon @click.stop.prevent="edit(index, item)" :to="{ name: 'film.maker.profile', params: { filmMakerId: item.id } }">
                      <v-icon small color="success">edit</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </template>
              </v-combobox>
            </v-flex>
            <!-- <v-flex xs4 class="pl-4 pr-1">
              <v-text-field
                v-model="film.producer_name"
                :label="$t('screener.film.producer.title')"
                type="text"
              ></v-text-field>
            </v-flex> -->
          </v-layout>
          <v-layout row wrap class="pt-2">
            <v-flex xs4 class="pt-2">
              <VimeoUploader
                @setUrl="setTrailer"
                v-model="film.trailer"
                label="Upload Trailer"
                :previewTitle="$t('screener.film.trailer_link.title')"
                refName="trailer"
              />
            </v-flex>
            <v-flex xs6 class="pt-2" v-if="!film.trailer">
              <v-text-field
                v-model="film.trailer_manual_link"
                :label="$t('screener.film.trailer_url.title')"
                type="text"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <!-- <v-flex xs12>
            <TextEditor
              :title="$t('screener.film.description')"
              v-model="film.description"
            />
          </v-flex> -->
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card fill-height class="mt-4">
      <v-card-title class="grey lighten-4 pa-2">
        <h4 class="secondary--text">
          {{ $t("screener.avails.additional_metadata.title") }}
        </h4>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="$emit('onSave',film)" small>Save</v-btn>
      </v-card-title>

      <v-card-text>
        <MediaMetadata
        :film.sync="film"
        ref="mediaMetaData"
        ></MediaMetadata>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import _ from 'lodash';
import rules from "@/validation";
import TextEditor from "@/components/TextEditor";
import MediaMetadata from "@/components/media/MetadataForm";
import VimeoUploader from "@/components/VimeoUploader";
import DEFINES from "@/defines";
import { mapState } from "vuex";

export default {
  name: "FilmBasicDetails",
  props: {
    film: {
      type: Object,
      default: null,
    },
  },
  components: {
    TextEditor,
    MediaMetadata,
    VimeoUploader,
  },
  data() {
    return {
      rules,
      filmMakers: [],
      selectedDirectors: [],
      director_ids: [],
      loading: false,
      search: null,
      widget_language:0,
      languages: DEFINES.LOCALES,
    };
  },
  computed:{
    ...mapState({
        company: (state) => state.company.company,
      }),
    enabledLanguages() {
      if (this.company) {
          return ('enabled_language_support' in this.company.custom_properties) ? this.company.custom_properties.enabled_language_support : this.i18n_locale; 
      }else{
          return this.i18n_locale
      }
    },
    currentLocale() {
      return this.$i18n.locale;
    }
  },
  created() {
    this.getFilmMakers()
  },
  methods: {
    setTrailer(url) {
      this.film.trailer = url;
      this.$emit("onSave", this.film);
    },

    async getFilmMakers() {
      await this.$store.dispatch('filmMaker/list')
      .then((res) => {
        this.filmMakers = res
      })
      .catch((error) => {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      })
    },

    async createFilmMaker() {
        this.loading = true
        await this.$store.dispatch('filmMaker/create', {
          name: {
            en : this.search,
            es : '',
            he : '',
            ru : '',
            it : ''
          }
        })
        .then((response) => {
          this.film.directors.push(response.film_maker)
          this.getFilmMakers()
        })
        .catch((error) => {
            this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: this.DEFINES.SNACKBAR_ERROR_COLOR,
            });
        })
        .finally(() => {
            this.loading = false
        })
    },
    onSaveDetails() {
      this.film.filmMaker_ids = this.film.directors.map(item => item.id)
      this.$emit('onSave', this.film)
    },
    setFieldLanguageData(fields, stateObject) {
      let __this = this
      fields.forEach(field => {
        __this.enabledLanguages.forEach((lang) => {
          if (lang.value !== 'en') {
            stateObject[field][lang.value] = stateObject[field]['en']
          }
        });
      });
    }
  }
};
</script>
